import axios from 'axios';

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const updateFormError = (error, input, inputError) => {
    const el = document.getElementById(input);
    const elError = document.getElementById(inputError);

    elError.innerHTML = `${error}`;
    el.classList.add('focus:outline-red-300');
    el.classList.add('border-red-500');
    el.focus();

    el.addEventListener('input', () => {
        elError.innerHTML = '';
        el.classList.remove('focus:outline-red-300');
        el.classList.remove('border-red-500');
    });
};

// Contact Form

const contactForm = document.getElementById('contact_form');
const contactFormSubmit = document.getElementById('contact-form-submit');
const contactFormSuccess = document.getElementById('contact-form-success');

if (contactForm) {
    contactForm.addEventListener('submit', (e) => {
        e.preventDefault();
        contactFormSubmit.setAttribute('disabled', true);

        axios
            .post(contactForm.action, new FormData(contactForm))
            .then((response) => {
                contactFormSubmit.removeAttribute('disabled');
                contactFormSuccess.innerHTML = 'Form submitted successfully';
                contactFormSuccess.style.display = 'block';
                contactForm.reset();

                setTimeout(() => {
                    contactFormSuccess.style.display = 'none';
                }, 2500);
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.data.error.name) {
                        updateFormError(error.response.data.error.name, 'contact-form-name', 'contact-form-name-error');
                        contactFormSubmit.removeAttribute('disabled');
                    }

                    if (error.response.data.error.email) {
                        updateFormError(
                            error.response.data.error.email,
                            'contact-form-email',
                            'contact-form-email-error'
                        );
                        contactFormSubmit.removeAttribute('disabled');
                    }

                    if (error.response.data.error.user_message) {
                        updateFormError(
                            error.response.data.error.user_message,
                            'contact-form-user-message',
                            'contact-form-user-message-error'
                        );
                        contactFormSubmit.removeAttribute('disabled');
                    }
                }
            });
    });
}

// Form Product Quote

const productQuoteForm = document.getElementById('product_quote');
const productQuoteSubmit = document.getElementById('product-quote-submit');
const productQuoteSuccess = document.getElementById('product-quote-success');

if (productQuoteForm) {
    productQuoteForm.addEventListener('submit', (e) => {
        e.preventDefault();
        productQuoteSubmit.setAttribute('disabled', true);

        axios
            .post(productQuoteForm.action, new FormData(productQuoteForm))
            .then((response) => {
                productQuoteSubmit.removeAttribute('disabled');
                productQuoteSuccess.innerHTML = 'Quote submitted successfully';
                productQuoteSuccess.style.display = 'block';
                productQuoteForm.reset();

                setTimeout(() => {
                    productQuoteSuccess.style.display = 'none';
                }, 2500);
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.data.error.name) {
                        updateFormError(
                            error.response.data.error.name,
                            'product-quote-name',
                            'product-quote-name-error'
                        );
                        productQuoteSubmit.removeAttribute('disabled');
                    }
                    if (error.response.data.error.email) {
                        updateFormError(
                            error.response.data.error.email,
                            'product-quote-email',
                            'product-quote-email-error'
                        );
                        productQuoteSubmit.removeAttribute('disabled');
                    }
                    if (error.response.data.error.organisation) {
                        updateFormError(
                            error.response.data.error.organisation,
                            'product-quote-organisation',
                            'product-quote-organisation-error'
                        );
                        productQuoteSubmit.removeAttribute('disabled');
                    }
                    if (error.response.data.error.country) {
                        updateFormError(
                            error.response.data.error.country,
                            'product-quote-country',
                            'product-quote-country-error'
                        );
                        productQuoteSubmit.removeAttribute('disabled');
                    }
                    if (error.response.data.error.delivery_address) {
                        updateFormError(
                            error.response.data.error.delivery_address,
                            'product-quote-delivery_address',
                            'product-quote-delivery_address-error'
                        );
                        productQuoteSubmit.removeAttribute('disabled');
                    }
                    if (error.response.data.error.user_message) {
                        updateFormError(
                            error.response.data.error.user_message,
                            'product-quote-user_message',
                            'product-quote-user_message-error'
                        );
                        productQuoteSubmit.removeAttribute('disabled');
                    }
                }
            });
    });
}

// Form Mailing List

const mailingListForm = document.getElementById('mailing_list');
const mailingListSubmit = document.getElementById('mailing-list-submit');
const mailingListSuccess = document.getElementById('mailing-list-success');

if (mailingListForm) {
    mailingListForm.addEventListener('submit', (e) => {
        e.preventDefault();
        mailingListSubmit.setAttribute('disabled', true);

        axios
            .post(mailingListForm.action, new FormData(mailingListForm))
            .then((response) => {
                mailingListSubmit.removeAttribute('disabled');
                mailingListSuccess.innerHTML = 'Successfully signed up';
                mailingListSuccess.style.display = 'block';
                mailingListForm.reset();

                setTimeout(() => {
                    mailingListSuccess.style.display = 'none';
                }, 2500);
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.data.error.name) {
                        updateFormError(
                            error.response.data.error.email,
                            'mailing-list-email',
                            'mailing-list-email-error'
                        );
                        productQuoteSubmit.removeAttribute('disabled');
                    }
                }
            });
    });
}
